import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const getTimeToLessonStart = (bookingStart: string, currentTime: string): number => {
  const date1 = dayjs(bookingStart, DateFormat.Default)
  const date2 = dayjs(currentTime, DateFormat.Default)
  const diff = date1.diff(date2, 'milliseconds')
  return isFinite(diff) ? diff : 0
}

export const getTimeToLessonStartInMilliseconds = (bookingStart: number, currentTime: number): number => {
  const diff = dayjs(bookingStart).diff(dayjs(currentTime))
  return isFinite(diff) ? diff : 0
}
